import { render, staticRenderFns } from "./PhoneInput.vue?vue&type=template&id=020a546b&scoped=true"
import script from "./PhoneInput.vue?vue&type=script&lang=js"
export * from "./PhoneInput.vue?vue&type=script&lang=js"
import style0 from "./PhoneInput.vue?vue&type=style&index=0&id=020a546b&prod&scoped=true&lang=css"
import style1 from "./PhoneInput.vue?vue&type=style&index=1&id=020a546b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020a546b",
  null
  
)

export default component.exports